<section id="container">
  <app-menu></app-menu>
  <section id="main-content">
    <section class="wrapper">
      <div class="header">
        <h3 class="title" i18n="task list page title|The title of the task list page shown to authenticated users@@TaskListPageTitle">Tasks</h3>
        <div class="actions">
          <button type="button" class="btn btn-primary add-task" (click)="onAddClick()"><i class="fa fa-plus"></i><span i18n="new task button label|Add task button label at the task list page@@addNewTaskButtonLabel">Add Task</span></button>
        </div>
      </div>
      <div *ngIf="error.active">
        <div class="error">
          <div class="alert alert-danger"><h4>{{ error.title }}</h4>{{ error.message }}</div>
          <pre style="margin-top: 10px">{{ error.stack }}</pre>
        </div>
      </div>
      <div *ngIf="!error.active" class="task-page-table">
        <app-filterable-paginated-table
          [columns]="columns"
          [data]="taskList"
          [pageSize]="pageSize"
          [paginationButtonsAllowed]="20"
          [loading]="loading"
          (actionClick)="onActionClick($event)"
          width="100%"
        ></app-filterable-paginated-table>
      </div>
    </section>
  </section>
</section>

<ng-template #removeModal let-modal>
  <div class="modal-header">
    <h4
      class="modal-title"
      i18n="task removal modal title|Title for the remove task modal at the task list page@@taskRemovalModalTitle"
    >Remove Task</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h6 i18n="task removal confirmation title|The main title to the remove task confirmation dialog@@taskRemovalConfirmationTitle">Are you sure you want to remove this task?</h6>
    <p i18n="action cannot be undone warning text|The generic warning that an action cannot be undone@@actionCannotBeUndoneWarning">This action cannot be undone.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Cancel')" i18n="@@genericCancelButtonLabel">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="modal.close('Remove')">Remove</button>
  </div>
</ng-template>

<ng-template #changeStatusModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="currentTask.active" i18n="@@titleDeactiveTaskListModal">Deactive Task</h4>
    <h4 class="modal-title" *ngIf="!currentTask.active" i18n="@@titleActiveTaskListModal">Active Task</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h6 *ngIf="currentTask.active" i18n="@@confirmTextDeactiveTask">Are you sure you want to Deactive this task?</h6>
    <h6 *ngIf="!currentTask.active" i18n="@@confirmTextActiveTask">Are you sure you want to Active this task?</h6>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Cancel')" i18n="@@genericCancelButtonLabel">Cancel</button>
    <button type="button" *ngIf="currentTask.active" class="btn btn-danger" (click)="modal.close('disable')" i18n="@@genericDeactivateButtonLabel">Deactive</button>
    <button type="button" *ngIf="!currentTask.active" class="btn btn-info" (click)="modal.close('enable')" i18n="@@genericActivateButtonLabel">Active</button>
  </div>
</ng-template>


<ng-template #cloneModal let-modal>
  <div class="modal-header">
    <h4
      class="modal-title"
      i18n="task clone modal title@@taskCloneModalTitle"
    >Clone Task</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h6 i18n="task clone confirmation title@@taskCloneConfirmationTitle">Are you sure you want to clone this task?</h6>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Cancel')" i18n="@@genericCancelButtonLabel">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="modal.close('Clone')" i18n="Generic Clone Button Label@@genericCloneButtonLabel">Clone</button>
  </div>
</ng-template>
